import React from 'react';
import { Box, Typography, Divider, Grid } from '@mui/material';

const PrintCertificate = ({ formData }) => {
  // डेटा रेषेच्या वर परफेक्ट बसवण्यासाठी स्टाईल
  const printValueStyle = {
    position: 'absolute',
    left: '5px',
    bottom: '1px',
    fontWeight: 'bold',
    color: '#000',
    fontSize: '15px',
    whiteSpace: 'nowrap',
    lineHeight: 1
  };

  const printLineWrapper = {
    position: 'relative',
    display: 'inline-block',
    borderBottom: '1px dotted #000',
    minHeight: '22px',
    verticalAlign: 'bottom'
  };

  return (
    <Box 
      id="exact-certificate-print-view" 
      sx={{ 
        lineHeight: 1.8, 
        fontSize: '14px', 
        color: '#000', 
        bgcolor: '#fff', 
        p: 2,
        boxSizing: 'border-box'
      }}
    >
      {/* Top Office Document Meta Rows */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', mb: 0.5, lineHeight: 1.4 }}>
        <Box>
          पॉडकास्ट रजिस्टर पानावरील क्रमांक ............................<br />
          तपासले कोड ......................................................<br />
          वर्ग ....................................................................<br />
          अनुक्रम ............................ विभाग ...........................<br />
          प्रवेश .................................................................<br />
          फीस रु ............................ पावती नं. ........................
        </Box>
        <Box sx={{ textAlign: 'right' }}>
          सामान्य रजिस्टर .....................................................
        </Box>
      </Box>

      <Box sx={{ textDecoration: 'underline', fontWeight: 'bold', mb: 0.5, fontSize: '12px' }}>
        मूळ प्रत / कार्यालयीन आवक क्रमांक: ........................ प्रमाणपत्र क्रमांक: ........................
      </Box>

      {/* Heading Institution Blocks */}
      <Box sx={{ textAlign: 'center', mb: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>रयत शिक्षण संस्था, सातारा</Typography>
        <Typography variant="caption" sx={{ display: 'block', fontWeight: 500 }}>पुणे विभाग</Typography>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', my: 0.2 }}>
          छत्रपती शिवाजी विद्यालय, ओझर (जुनिअर कॉलेज) भोर, पुणे
        </Typography>
        <Divider sx={{ my: 0.5, borderColor: '#000', borderBottomWidth: 1.5 }} />
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', letterSpacing: 0.5, mb: 1, textDecoration: 'underline' }}>
          शाळा सोडल्याचे प्रमाणपत्र
        </Typography>
      </Box>

      {/* Identifiers */}
      <Box sx={{ lineHeight: 1.6 }}>
        स्टूडंट आय.डी. : <span style={{ ...printLineWrapper, width: '80%' }}><span style={printValueStyle}>{formData.studentId}</span></span> <br />
        यु.आय.डी.नं. (आधार कार्ड क्रमांक) : <span style={{ ...printLineWrapper, width: '68%' }}><span style={printValueStyle}>[Aadhaar Redacted]</span></span>
      </Box>

      {/* Blueprint Structure Content Rows */}
      <Box sx={{ mt: 0.5, fontSize: '14px', '& > div': { display: 'flex', alignItems: 'flex-end', mb: 0.2 } }}>
        <div>
          विद्यार्थ्याचे संपूर्ण नांव - (नांव) 
          <Box sx={{ ...printLineWrapper, width: '20%', mx: 0.5 }}><span style={printValueStyle}>{formData.firstName}</span></Box>
          -(वडिलांचे नांव) 
          <Box sx={{ ...printLineWrapper, width: '25%', mx: 0.5 }}><span style={printValueStyle}>{formData.middleName}</span></Box>
          -(आडनांव) 
          <Box sx={{ ...printLineWrapper, flexGrow: 1, ml: 0.5 }}><span style={printValueStyle}>{formData.lastName}</span></Box>
        </div>

        <div>
          आईचे नांव 
          <Box sx={{ ...printLineWrapper, flexGrow: 1, ml: 1 }}><span style={printValueStyle}>{formData.motherName}</span></Box>
        </div>

        <Box sx={{ display: 'flex', width: '100%' }}>
          <Box sx={{ display: 'flex', alignItems: 'flex-end', width: '50%' }}>
            राष्ट्रीयत्व 
            <Box sx={{ ...printLineWrapper, flexGrow: 1, mx: 1 }}><span style={printValueStyle}>{formData.nationality}</span></Box>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'flex-end', width: '50%' }}>
            मातृभाषा 
            <Box sx={{ ...printLineWrapper, flexGrow: 1, ml: 1 }}><span style={printValueStyle}>{formData.motherTongue}</span></Box>
          </Box>
        </Box>

        <div>
          धर्म 
          <Box sx={{ ...printLineWrapper, width: '25%', mx: 1 }}><span style={printValueStyle}>{formData.religion}</span></Box>
          -जात 
          <Box sx={{ ...printLineWrapper, width: '25%', mx: 1 }}><span style={printValueStyle}>{formData.caste}</span></Box>
          -पोटजात 
          <Box sx={{ ...printLineWrapper, flexGrow: 1, ml: 1 }}><span style={printValueStyle}>{formData.subCaste}</span></Box>
        </div>

        <div>
          जन्मस्थळ (गांव/शहर) 
          <Box sx={{ ...printLineWrapper, width: '22%', mx: 0.5 }}><span style={printValueStyle}>{formData.birthPlace}</span></Box>
          -तालुका 
          <Box sx={{ ...printLineWrapper, width: '20%', mx: 0.5 }}><span style={printValueStyle}>{formData.taluka}</span></Box>
          -जिल्हा 
          <Box sx={{ ...printLineWrapper, flexGrow: 1, ml: 0.5 }}><span style={printValueStyle}>{formData.district}</span></Box>
        </div>

        <div>
          इ.सनाच्या प्रमाणे जन्म दिनांक 
          <Box sx={{ ...printLineWrapper, flexGrow: 1, ml: 1 }}><span style={printValueStyle}>{formData.dobDigit}</span></Box>
        </div>

        <div>
          जन्म दिनांक अक्षरी 
          <Box sx={{ ...printLineWrapper, flexGrow: 1, ml: 1 }}><span style={printValueStyle}>{formData.dobWords}</span></Box>
        </div>

        <div>
          या पूर्वीची शाळा व इयत्ता 
          <Box sx={{ ...printLineWrapper, flexGrow: 1, ml: 1 }}><span style={printValueStyle}>{formData.prevSchool}</span></Box>
        </div>

        <div>
          या शाळेत प्रवेश घेतल्याचा दिनांक 
          <Box sx={{ ...printLineWrapper, width: '35%', mx: 1 }}><span style={printValueStyle}>{formData.admissionDate}</span></Box>
          इयत्ता 
          <Box sx={{ ...printLineWrapper, flexGrow: 1, ml: 1 }}><span style={printValueStyle}>{formData.admissionClass}</span></Box>
        </div>

        <div>
          अभ्यासातील प्रगती 
          <Box sx={{ ...printLineWrapper, width: '40%', mx: 1 }}><span style={printValueStyle}>{formData.progress}</span></Box>
          वर्तणूक 
          <Box sx={{ ...printLineWrapper, flexGrow: 1, ml: 1 }}><span style={printValueStyle}>{formData.conduct}</span></Box>
        </div>

        <div>
          शाळा सोडल्याचा दिनांक 
          <Box sx={{ ...printLineWrapper, flexGrow: 1, ml: 1 }}><span style={printValueStyle}>{formData.leavingDate}</span></Box>
        </div>

        <div>
          कोणत्या इयत्तेत शिकत होता व केव्हापासून (अक्षरी व अंकी) 
          <Box sx={{ ...printLineWrapper, flexGrow: 1, ml: 1 }}><span style={printValueStyle}>{formData.currentClassDetails}</span></Box>
        </div>

        <div>
          शाळा सोडण्याचे कारण--------------------------------------------------------------------------------------
          <Box sx={{ position: 'absolute', left: '130px', bottom: '1px', fontWeight: 'bold' }}>{formData.leavingReason}</Box>
        </div>

        <div>
          शेरा.----------------------------------------------------------------------------------------------------
          <Box sx={{ position: 'absolute', left: '50px', bottom: '1px', fontWeight: 'bold' }}>{formData.remark || (formData.progress === 'चांगली' ? 'पास झाला' : '')}</Box>
        </div>
      </Box>

      {/* =========================================================
          ३. फुटर भाग (नवीन स्क्रीनशॉटनुसार तंतोतंत अलाईन्मेंट)
          ========================================================= */}
      <Box sx={{ mt: 3, fontSize: '15px', position: 'relative' }}>
        दाखला देण्यात येतो की, वरील माहिती शाळेतील जनरल रजिस्टर नं. <span style={{ fontWeight: 'bold', borderBottom: '1px dotted #000', padding: '0 10px' }}>{formData.generalRegisterNo || '१'}</span> प्रमाणे आहे.
      </Box>
      
      {/* तारीख, माहे, सन - रेषा आणि डेटा फिक्स लेआउट */}
      <Box sx={{ mt: 2, fontSize: '15px', display: 'flex', alignItems: 'center', width: '100%', position: 'relative' }}>
        <Box sx={{ width: '35%', display: 'flex', alignItems: 'flex-end' }}>
          तारीख-----------------------
          <span style={{ position: 'absolute', fontWeight: 'bold', left: '50px', bottom: '2px' }}>{formData.dateDay}</span>
        </Box>
        <Box sx={{ width: '35%', display: 'flex', alignItems: 'flex-end', position: 'relative' }}>
          माहे------------------------
          <span style={{ position: 'absolute', fontWeight: 'bold', left: '40px', bottom: '2px' }}>{formData.dateMonth}</span>
        </Box>
        <Box sx={{ width: '30%', display: 'flex', alignItems: 'flex-end', position: 'relative' }}>
          सन-------------------------
          <span style={{ position: 'absolute', fontWeight: 'bold', left: '30px', bottom: '2px' }}>{formData.dateYear}</span>
        </Box>
      </Box>

      {/* वर्गशिक्षक / लेखनिक / मुख्याध्यापक सही ब्लॉक */}
      <Grid container sx={{ mt: 8, px: 1, fontSize: '15px', alignItems: 'flex-start' }}>
        <Grid item xs={4} sx={{ textAlign: 'left' }}>
          <Typography variant="body1" sx={{ fontWeight: '500' }}>वर्गशिक्षक /-</Typography>
        </Grid>
        <Grid item xs={4} sx={{ textAlign: 'center' }}>
          <Typography variant="body1" sx={{ fontWeight: '500' }}>लेखनिक /-</Typography>
        </Grid>
        <Grid item xs={4} sx={{ textAlign: 'right', pr: 1 }}>
          <Typography variant="body1" sx={{ lineHeight: 1.4, fontWeight: 'bold' }}>
            सही /-<br />
            मुख्याध्यापक/प्राचार्य<br />
            (शिक्का)
          </Typography>
        </Grid>
      </Grid>

      {/* टीप कायदेशीर कारवाई ओळ */}
      <Box sx={{ mt: 4, pt: 1, fontSize: '13px', lineHeight: 1.4 }}>
        <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5 }}>टीप :-</Typography>
        <div>१) शाळा सोडल्याचे दाखल्यामध्ये अनाधिकृतरीत्या बदल केल्यास संबंधितांवर कायदेशीर कारवाई करण्यात येईल.</div>
        <Divider sx={{ mt: 1.5, borderColor: '#000000', borderStyle: 'dashed' }} />
      </Box>
    </Box>
  );
};

export default PrintCertificate;